const SESSION_KEY = "login-response";

export type LoginResponse = {
  status: string;
  name: string;
  orgId: string;
  isAgp: string;
  email: string;
  mobile: string;
  countryCode: string;
  id: string;
  usertype: string[];
  userId: string;
  roles: string[];
  accessibleScreens: unknown[];
  subscriptionExpiryDate: string;
  welcomeNotification: Record<string, string>;
  permissions: {
    appName: string;
    permissions: Permission[];
  };
  canDeactivateRestore: boolean;
  defaultOrgId: string;
  dashboardPages: string[];
  token: string;
  refreshToken: string;
  exp?: string | number;
};

type Permission = {
  moduleName: string;
  operations: Operation[];
};

type Operation = {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
};

export const getLoginResponse = (): LoginResponse | null => {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as LoginResponse;
  } catch {
    return null;
  }
};

export const saveSession = (session: LoginResponse): void => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const clearSession = (): void => {
  localStorage.clear();
};

export const getAccessToken = (): string | null => getLoginResponse()?.token ?? null;

export const getRefreshToken = (): string | null => getLoginResponse()?.refreshToken ?? null;
